import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { decodeName, getTranslations } from "../../../Common/utils";
import { useNavigate } from "react-router-dom";
import { getPath } from "../../../Common/utils";
import { league } from "../../../redux/actions";
import { CtaButton } from "../../Buttons";
import useTournamentScanario from "../../../Common/hooks/useTournamentScanario";
import TeamSerialNumber from "../../TeamSerialNumber";

const List = ({ leagueManageConfig }) => {
  const dispatch = useDispatch();
  const {
    leagueManageCTA = false,
    data,
    adminSocialId = "",
    selectMember,
    isAdminData,
    isAdmin,
    maxTeams = 0,
    currentLeagueAdmin,
  } = leagueManageConfig;

  const [adminSocialID, setAdminSocialID] = useState("");
  const { isEos, lastGamedayRaceLocked } = useTournamentScanario();

  const disableCTAs = isEos || lastGamedayRaceLocked;

  useEffect(() => {
    if (adminSocialId.length > 0) {
      setAdminSocialID(adminSocialId);
    }
  }, [adminSocialId]);

  const navigate = useNavigate();
  const userState = useSelector((state) => state.user);
  const leagueState = useSelector((state) => state.league);
  const translationState = useSelector((state) => state.translation);

  const { selectedLeague } = leagueState;
  const leagueCode = selectedLeague?.league_code;
  const SocialId = userState?.data?.SocialId;

  const toggleRemoveMember = (item) => {
    dispatch(league.toggleRemoveMember(item));
  };

  // if (
  //   !isAdminData &&
  //   data?.length === 1 &&
  //   data?.[0]?.socialId === adminSocialID
  // ) {
  //   return isAdmin ? (
  //     <NoDataFound
  //       noDataCaption={getTranslations(
  //         "manage_league_no_team_found",
  //         "No Team Found"
  //       )}
  //     />
  //   ) : null;
  // }

  const displayAddTeam = (userEntry) => {
    if (!userEntry) return false;
    const userTeamNo = userEntry?.userTeamNo;
    const userTeamsLeagueJoinedCount = userTeamNo?.length;
    if (userTeamsLeagueJoinedCount < maxTeams) {
      return true;
    }
    return false;
  };

  const isCurrentUser = (item) => {
    return parseInt(item?.socialId) === parseInt(SocialId);
  };

  const getCurrentUserEntry = () => {
    return data?.find((item) => isCurrentUser(item));
  };

  const getOtherMembers = () => {
    return data?.filter((item) => !isCurrentUser(item));
  };

  const currentUserEntry = getCurrentUserEntry();
  const otherMembers = getOtherMembers();

  // Get unjoined teams - all available team slots from 1 to maxTeams that aren't joined
  const getUnjoinedTeams = (userEntry) => {
    if (!userEntry || !maxTeams) return [];
    const joinedTeamNos = userEntry?.userTeamNo || [];
    // Generate all possible team numbers from 1 to maxTeams
    const allPossibleTeams = Array.from({ length: maxTeams }, (_, i) => i + 1);
    // Filter out already joined teams
    const unjoinedTeams = allPossibleTeams.filter(
      (teamNo) => !joinedTeamNos.includes(teamNo)
    );
    return unjoinedTeams;
  };

  const isItemAdmin = (item) => {
    if (item?.isAdmin) return true;
    // Check if item is in currentLeagueAdmin array
    if (currentLeagueAdmin && Array.isArray(currentLeagueAdmin)) {
      const isInAdminList = currentLeagueAdmin.some(
        (admin) => String(admin?.socialId) === String(item?.socialId)
      );
      if (isInAdminList) return true;
    }

    // Check if currentLeagueAdmin is an object and matches the item
    if (currentLeagueAdmin && !Array.isArray(currentLeagueAdmin)) {
      const adminSocialId =
        currentLeagueAdmin?.socialId || currentLeagueAdmin?.socialid;
      if (
        adminSocialId &&
        (String(item?.socialId) === String(adminSocialId) ||
          parseInt(item?.socialId) === parseInt(adminSocialId))
      ) {
        return true;
      }
    }

    // Otherwise, check if socialId matches adminSocialID
    if (!item?.socialId || !adminSocialID) return false;
    return (
      String(item?.socialId) === String(adminSocialID) ||
      parseInt(item?.socialId) === parseInt(adminSocialID)
    );
  };

  return (
      <div className="si-league__manage-list si-league__manage-list--withName">
        <ul>
          {/* Current User's Entry */}
          {currentUserEntry && (
            <li>
              <div className="si-league__manage-box si-league__manage-box--current-user">
                <div className="si-league__manage-user">
                  <span>
                    {currentUserEntry?.userName
                      ? currentUserEntry?.userName
                      : getTranslations(
                          "league_manage_player_name",
                          "Player name"
                        )}
                  </span>
                  {isItemAdmin(currentUserEntry) && (
                    <span className="si-league__manage-admin-badge">
                      {getTranslations("league_manage_admin_badge", "ADMIN")}
                    </span>
                  )}
                </div>
                <div className="si-league__manage-grid si-league__manage-grid--current-user">
                  <div className="si-league__manage-lhs">
                    <div className="si-league__manage-team si-league__manage-team--current-user">
                      {currentUserEntry?.userTeamNo?.map((x, index) => (
                        <div key={index} className="si-league__manage-team-box">
                          <TeamSerialNumber teamNumber={x} />
                          <span className="si-league__manage-team-name">
                            {decodeName(currentUserEntry?.teamName?.[index]) ||
                              getTranslations(
                                "league_manage_team_name",
                                "Team name"
                              )}
                          </span>
                        </div>
                      ))}
                      {displayAddTeam(currentUserEntry) && (
                        <div className="si-league__manage-team-addTeam-wrapper">
                          {/* Show unjoined team boxes */}
                          <div className="si-league__manage-team-addTeam-wrapperLHS">
                            {getUnjoinedTeams(currentUserEntry).map(
                              (teamNo, index) => (
                                <div
                                  key={index}
                                  className="si-league__manage-team-pill-wrapper"
                                >
                                  <TeamSerialNumber
                                    teamNumber={teamNo}
                                    isInactive={true}
                                  />
                                </div>
                              )
                            )}
                          </div>
                          <CtaButton
                            variant={"ghost"}
                            icon="f1i-add"
                            disabled={disableCTAs}
                            onClick={() => {
                              navigate(
                                getPath(
                                  translationState,
                                  "selectedJoinLeague",
                                  {
                                    code: leagueCode,
                                  }
                                )
                              );
                            }}
                            className="si-league__manage-add-team-btn"
                          >
                            <span className="si-league__manage-add-team-text">
                              {getTranslations(
                                "league_manage_add_team",
                                "Add team"
                              )}
                            </span>
                          </CtaButton>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </li>
          )}

          {/* Other Members */}
          {otherMembers?.map((item, index) => {
            return (
              <li key={index}>
                <div className="si-league__manage-box">
                  <div className="si-league__manage-grid">
                    <div className="si-league__manage-lhs">
                      <div className="si-league__manage-user">
                        <span>
                          {item?.userName
                            ? item?.userName
                            : getTranslations(
                                "league_manage_player_name",
                                "Player name"
                              )}
                        </span>
                        {isItemAdmin(item) && (
                          <span className="si-league__manage-admin-badge">
                            {getTranslations(
                              "league_manage_admin_badge",
                              "ADMIN"
                            )}
                          </span>
                        )}
                      </div>
                      <div className="si-league__manage-team-pills">
                        {item?.userTeamNo?.map((x, index) => (
                          <div
                            key={index}
                            className="si-league__manage-team-pill-wrapper"
                          >
                            <TeamSerialNumber teamNumber={x} />
                          </div>
                        ))}
                      </div>
                    </div>
                    {leagueManageCTA &&
                      item?.socialId !== adminSocialId &&
                      !isAdminData &&
                      !isItemAdmin(item) && (
                        <div className="si-league__manage-rhs">
                          <CtaButton
                            size={"md"}
                            variant={"link"}
                            disabled={disableCTAs}
                            onClick={() => toggleRemoveMember(item)}
                          >
                            {getTranslations("league_manage_remove", "Remove")}
                          </CtaButton>
                        </div>
                      )}
                  </div>
                </div>
              </li>
            );
          })}
        </ul>
      </div>
  );
};

export default List;
